import {
    Locale,
    GameName,
    gameSettings,
    DefaultLocale,
} from "inbox-contentful";

const gameName: GameName = "clashofclans";

export const config = {
    gameName,
    gameResolution: {
        x: 740,
        y: 480,
    },
    locales: (gameSettings[gameName]?.enabledLocales ?? [
        DefaultLocale,
    ]) as Locale[],
    tabs: ["news", "community", "esport"],
    isFullScreen: false,
};
